var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"start",attrs:{"fill-height":false,"fluid":"","pt-0":""}},[_c('v-app-bar',{attrs:{"app":"","color":"black","dark":"","fixed":""}},[(_vm.$vuetify.breakpoint.mdAndDown)?[_c('hb-main-menu-button')]:_vm._e(),_c('v-toolbar-title'),_c('v-spacer')],2),(_vm.showNoPermissions)?[_c('no-permissions-view')]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }